import React, { Component, useMemo } from "react";
import db from "../../pages";
import { FaAngleDown, FaAngleRight } from "react-icons/fa"
import { fetchData } from "../common/networkRequests";
import { handleLogout, RelevantIcon, setCookie, toTitleCase, toggleSidebar } from "../oro-module/commonFunctions";
// import "../../styles/sidebar.css"
import sidebarItems, { findInSidebar } from "./sidebarItems";
import { Alert, UncontrolledTooltip } from "reactstrap";
import { handlePageChange } from "../oro-module/ajaxdata";

function isSearched(fastpath, searched) {
  return fastpath.indexOf(searched) != -1;
}

const collaborationTools = [
  // {
  //   fastpath: "ecompliancehome",
  //   label: "Comment",
  //   icon: "comment",
  //   id: "comment"
  // },
  // {
  //   fastpath: "ecompliancehome",
  //   label: "Present",
  //   icon: "present",
  //   id: "present"
  // }
]


const Sidebar = ({ themecolor, level, sidebarItems, current, currentPage, showfull }) => {
  let fromtop = current.props.parentState[`leftSidebar${level}Top`];
  let { showSidebar } = current.props.parentState;
  let collapsed = 3;
  let firstWidth = 14;
  let secondwidth = 18;

  let left = level == 1 ? 0 : (level == 2 && !showfull) ? `${collapsed}%` : (level == 2 && showfull) ? `${firstWidth}%` : (level == 3 && !showfull) ? `${collapsed + secondwidth}%` : (level == 3 && showfull) ? `${firstWidth + secondwidth}%` : "28%";
  let width = (!showfull && level == 1) ? "3.5%" : (showfull && level == 1) ? "14%" : "18%";
  // left=`calc(${left}-7px)`;
  let ht = window.screen.height;
  return (
    <div
      className={`${themecolor}-sidebar-theme `} id={`leftSidebar${level > 1 ? level : ""}`}
      style={{
        float: "left",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        overflow: "hidden",
        padding: 0,
        top: fromtop,
        left,
        width
      }}
    >
      <div
      // className="hand"
      >
        <span
          style={{
            fontSize: "1rem ",
            lineHeight: "2",
            color: "#495057",
            width: "100%",
            backgroundColor: "#fff",
            height: 30
          }}
        ></span>
      </div>


      <div
        className="col-sm-12 sidebar"
        style={{
          minHeight: level == 1 ? 550 : 0, maxHeight: level == 1 ? 550 : 550,
          // borderBottom: "2px solid lightgray", 

        }}
      >
        {sidebarItems.map((item, idx) => <SidebarItem key={idx} idx={idx} current={current} item={item} currentPage={currentPage} showfull={showfull} theme={themecolor} level={level} />)}
      </div>


      <div
        className="col-sm-12  sidebar sidebar-toggler-container" onClick={() => toggleSidebar(current)}
      >
        <div className={showSidebar ? 'sidebar-toggler-full' : 'sidebar-toggler-half'}>
          {showSidebar &&
            <span>&nbsp; &nbsp; &nbsp;</span>
          }
          <RelevantIcon style={{ color: "#5F6368" }} icon={showSidebar ? "left-carat" : "right-carat"} />
        </div>
      </div>



      {level == 1 &&
        <div
          className="col-sm-12 sidebar"
          style={{ overflow: "auto", paddingTop: '15px' }}
        >
          <div style={{ fontSize: 18, marginLeft: -10, fontWeight: 'bold' }}>{showfull ? 'Team' : ' '}</div>
          {collaborationTools.map((item, idx) => <SidebarItem key={idx} idx={idx} current={current} item={item} currentPage={currentPage} showfull={showfull} theme={themecolor} level={level} />)}
        </div>
      }
    </div>
  )
}


export const LeftSidebarMore = ({ current, level }) => {
  let { showSidebar } = current.state;

  let nc = {
    props: {
      parentState: current.state,
      parentProps: current.props,
      liftGlobalState: current.liftGlobalState,
      liftState: current.liftState,
      liftWrapperState: current.props.liftGlobalState
    }
  }
  const { themecolor, currentPage, leftSidebar2Items, leftSidebar3Items } = current.state;
  let sidebarItems = level == 2 ? leftSidebar2Items : leftSidebar3Items;
  // debugger;
  return (
    <Sidebar themecolor={themecolor} level={level} sidebarItems={sidebarItems} showfull={showSidebar} current={nc} currentPage={currentPage} />
  )
}


const SidebarItem = ({ item, theme, showfull, current, level, idx }) => {
  let { fastpath, icon, label, items, id } = item;
  // let selected={[`leftSidebar${level}Selected`]:}
  let cur = current.props.parentState[`leftSidebar${level}Selected`];
  let leftSidebarLevel = current.props.parentState[`leftSidebarLevel`];

  const handlePageClick = ({ event, item, current }) => {
    let fromtop = 60 + (33 * parseInt(idx));
    if (level > 1) {
      fromtop = current.props.parentState[`leftSidebar${level}Top`] + (33 * parseInt(idx));
    }

    // if (item.active) {
    // set level 2 visible and current clicked.
    if (item.download) {
      window.open(item.download, '_blank').focus();
    } else if (item.fastpath) {
      current.props.liftGlobalState({ name: `leftSidebar${level}Selected` }, item.fastpath);
      if (item.items) {
        current.props.liftGlobalState({ name: `leftSidebar${level + 1}Selected` }, "");
        current.props.liftGlobalState({ name: `leftSidebar${level + 2}Selected` }, "");
        if (cur == fastpath && leftSidebarLevel != level) {
          current.props.liftGlobalState({ name: `leftSidebar${level}Selected` }, "");
          current.props.liftGlobalState({ name: "leftSidebarLevel" }, level);
        } else {
          current.props.liftGlobalState({ name: `leftSidebar${level + 1}Top` }, fromtop);
          current.props.liftGlobalState({ name: "leftSidebarLevel" }, level + 1);
          current.props.liftGlobalState({ name: `leftSidebar${level + 1}Items` }, item.items);
        }
      } else {
        // if (item.active) {
        handlePageChange({ item, current });
        // }
      }
    }
  }

  return (
    <div
      style={{
        // borderBottom: "1px solid lightgray"
      }}
      className={`sidebarItem row ${cur == fastpath
        ? "selected-sidebar"
        : ""
        } `}
      onClick={event => handlePageClick({ event, item, current })}
    // onMouseOver={event => {
    //   if (cur != fastpath && items) {
    //     handlePageClick({ event, item, current });
    //   }
    // }}
    >
      <div className="sidebar-icon" id={fastpath + idx} style={{ color: cur == fastpath ? "#D93827" : "#3282b8", textAlign: icon ? "center" : "right" }}>
        {icon &&
          <RelevantIcon style={{ fontSize: (!showfull && level == 1) ? 25 : 25, color: cur == fastpath ? "#D93827" : "#3282b8" }} icon={icon} />
        }
        {!icon &&
          <span>{idx + 1}.</span>
        }
      </div>

      {/* {!showfull && level == 1 &&
        <UncontrolledTooltip style={{ fontWeight: "bold", backgroundColor: "#202020", color: "white" }} placement="bottom" target={fastpath + idx}>
          {label ? label : db[fastpath] ? db[fastpath].label : ""}
        </UncontrolledTooltip>
      } */}



      {((!showfull && level != 1) || showfull) && idx == 0 &&
        <div className={`${theme}-sidebar-text sidebar-text`} style={{
          width: icon ? "78%" : "85%",
        }}>
          &nbsp; {label}
        </div>
      }

      {((!showfull && level != 1) || showfull) && idx == 1 &&
        <div className={`${theme}-sidebar-text sidebar-text`} style={{
          width: icon ? "78%" : "85%"
        }}>
          &nbsp; {label}
        </div>
      }

      {((!showfull && level != 1) || showfull) && idx == 2 &&
        <div className={`${theme}-sidebar-text sidebar-text`} style={{
          width: icon ? "78%" : "85%",
          // marginBottom: 10
        }}>
          &nbsp; {label}
        </div>
      }




      {((!showfull && level != 1) || showfull) && idx > 2 &&
        <div className={`${theme}-sidebar-text sidebar-text`} style={{
          width: icon ? "78%" : "85%"
        }}>
          &nbsp; {label ? label.replace(/_/g, ' ') : db[fastpath] ? toTitleCase(db[fastpath].label.replace(/_/g, ' ')) : ""}
        </div>
      }


      {/* {items &&
        <div style={{ width: "7%", paddingTop: 3 }}>
          <FaAngleRight />
        </div>
      } */}

      {/* {((!showfull && level != 1) || showfull) && items &&
        <div style={{ width: "10%", paddingTop: 3 }}>
          <FaAngleRight />
        </div>
      } */}
    </div>
  )
}



const LeftSidebar = (props) => {

  let { themecolor, LocalVars, currentPage, showSidebar } = props.parentState;
  let { profile } = props.parentProps.parentState;
  let items = profile.favourites;
  let { sidebarSearch } = LocalVars;

  // items = useMemo(() => username != 'apex' ? findInSidebar(profile) : [], [forms]);
  if (props.parentProps.parentState.identi) {
    items = [];
  }


  return <Sidebar themecolor={themecolor} showfull={showSidebar} level={1} sidebarItems={items} current={{ props }} currentPage={currentPage} />
}

export default LeftSidebar;